import * as actionTypes from 'src/old/actions';

const initialState = { payments: [] };

const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PAYMENTS: {
      return {
        ...state,
        payments: action.response
      };
    }

    case actionTypes.EDIT_PAYMENTS: {
      return {
        ...state,
        payments: [...state.payments.filter(payment => payment.id !== action.response.id)]
      };
    }

    default: {
      return state;
    }
  }
};

export default paymentsReducer;
